import { render, staticRenderFns } from "./ReturnOrderShippingView.vue?vue&type=template&id=0ed6691c&"
import script from "./ReturnOrderShippingView.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderShippingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed6691c')) {
      api.createRecord('0ed6691c', component.options)
    } else {
      api.reload('0ed6691c', component.options)
    }
    module.hot.accept("./ReturnOrderShippingView.vue?vue&type=template&id=0ed6691c&", function () {
      api.rerender('0ed6691c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnOrderShippingView.vue"
export default component.exports